import { render, staticRenderFns } from "./MenuItemBoxLibrary.vue?vue&type=template&id=2a55041d&"
import script from "./MenuItemBoxLibrary.vue?vue&type=script&lang=js&"
export * from "./MenuItemBoxLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports